export default function cyrilicThaiMixTransform(input) {
  return input
    .replace(/a/gi, "ล")
    .replace(/b/gi, "в")
    .replace(/c/gi, "¢")
    .replace(/d/gi, "∂")
    .replace(/e/gi, "э")
    .replace(/f/gi, "ƒ")
    .replace(/g/gi, "φ")
    .replace(/h/gi, "ђ")
    .replace(/i/gi, "เ")
    .replace(/j/gi, "נ")
    .replace(/k/gi, "к")
    .replace(/l/gi, "ℓ")
    .replace(/m/gi, "м")
    .replace(/n/gi, "и")
    .replace(/o/gi, "๏")
    .replace(/p/gi, "ק")
    .replace(/q/gi, "ợ")
    .replace(/r/gi, "я")
    .replace(/s/gi, "ร")
    .replace(/t/gi, "†")
    .replace(/u/gi, "µ")
    .replace(/v/gi, "√")
    .replace(/w/gi, "ω")
    .replace(/x/gi, "җ")
    .replace(/y/gi, "ý")
    .replace(/z/gi, "ž")
    .replace(/ /gi, "ㅤ");
}
